//#region Styles
import { Column, Row } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import TooltipButton from "components/TooltipButton/TooltipButton";
import RequiredInformationForm from "components/RequiredInformationForm/RequiredInformationForm";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { ERROR_TEXT_LIST } from "../utils/constants";
import useChangeLibraryListByCampus from "views/Recursos/ResourcesLibrary/utils/hooks/useChangeLibraryListByCampus";
import { WIDTH_SELECT_CONTROL, WIDTH_INPUT_TEXT_CONTROL } from "../../utils/constants";
import ChangeHistory from "../../components/ChangeHistory/ChangeHistory";
//#endregion

const Fields = ({
    isAdmin,
    currentElectronicResourceForUpdate,
    currentTextService, toggleShowDialogToggleActivationResource,
    form, setCurrentResourceTypeIdToForm,
    data: {
        brands,
        campusList,
        libraryList,
        resourceTypes
    },
    isCreate,
    loadingRequest
}) => {
    const { 
        campusId, libraryId, 
        resourceTypeId, 
        name, active } = form.value;
    //#region Functions
    const changeCampusField = value => {
        form.change("campusId", value);
    }
    const changeLibraryField = value => {
        form.change("libraryId", value);
    }
    const changeResourceTypeId = value => {
        form.change("resourceTypeId", value);
        setCurrentResourceTypeIdToForm(value);
    }
    const changeBrandId = value => {
        form.change("brandId", value);
    }
    const changeModel = value => {
        form.change("model", value);
    }
    const changeSerial = value => {
        form.change("serial", value);
    }
    const changeActiveField = () => {
        form.toggleActiveField();
        toggleShowDialogToggleActivationResource(true);
    }
    const renderBarcodeField = () => {
        return (
            <CustomTextInput 
                {...WIDTH_INPUT_TEXT_CONTROL}
                label="Código de barras"
                placeholder="Ejm: 8328439JD"
                value={form.value.barcode}
                error={form.errors.value.barcode}
                errorText={ERROR_TEXT_LIST.BARCODE}
                onChange={value => form.change("barcode", value)}
                maxLength={30}
                required/> 
        );
    }
    //#endregion
    const { libraryListByCampus } = useChangeLibraryListByCampus({
        currentResourceForUpdate: currentElectronicResourceForUpdate,
        campusId,
        changeLibraryField,
        libraryList
    });
    const { isResource } = form;
    return (
        <Container className="custom-scrollbar primary">
            <Row justifyContent="flex-start">
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Campus"
                    value={campusId}
                    errorText={ERROR_TEXT_LIST.CAMPUS_ID}
                    optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                    onChange={changeCampusField}
                    defaultOptionText="Elige un Campus"
                    disabled={!isCreate || !isAdmin}
                    required={isCreate}/>
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Biblioteca"
                    value={libraryId}
                    error={form.errors.value.libraryId}
                    errorText={ERROR_TEXT_LIST.LIBRARY_ID}
                    optionsProps={getOptionsToCustomSelect(libraryListByCampus, { id: "id", text: "name" })}
                    onChange={changeLibraryField}
                    defaultOptionText="Elige una Biblioteca"
                    disabled={!isCreate || libraryListByCampus.length === 0}
                    required={isCreate}/>
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Recurso"
                    value={resourceTypeId}
                    error={form.errors.value.resourceTypeId}
                    optionsProps={getOptionsToCustomSelect(resourceTypes, { id: "id", text: "name" })}
                    onChange={changeResourceTypeId}
                    defaultOptionText="Elige un Recurso"
                    disabled={!isCreate}
                    required={isCreate}/>
            </Row>
            <Row justifyContent="flex-start">
                <CustomTextInput 
                    label="Nombre del recurso"
                    value={name || "-"}
                    {...WIDTH_INPUT_TEXT_CONTROL}
                    disabled/>
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Marca"
                    value={form.value.brandId}
                    error={form.errors.value.brandId}
                    errorText={ERROR_TEXT_LIST.BRAND_ID}
                    onChange={changeBrandId}
                    optionsProps={getOptionsToCustomSelect(brands, { id: "id", text: "name" })}
                    required={brands.length > 0}
                    disabled={brands.length === 0}/>
                {isResource.tablet &&
                <CustomTextInput 
                    {...WIDTH_INPUT_TEXT_CONTROL}
                    label="Modelo"
                    value={form.value.model}
                    placeholder="Ejm: SM-P5690"
                    error={form.errors.value.model}
                    errorText={ERROR_TEXT_LIST.MODEL}
                    onChange={changeModel}
                    maxLength={40}
                    required/>}
                {isResource.pc && renderBarcodeField()}
            </Row>
            {isResource.tablet &&
            <Row>
                <CustomTextInput 
                    {...WIDTH_INPUT_TEXT_CONTROL}
                    label="Serie"
                    placeholder="Ejm: TUEI879"
                    value={form.value.serial}
                    error={form.errors.value.serial}
                    errorText={ERROR_TEXT_LIST.SERIAL}
                    onChange={changeSerial}
                    maxLength={20}
                    required/>
                {renderBarcodeField()}
            </Row>}
            <CustomTextArea 
                label="Detalles"
                placeholder="Ejm: Comprado el día 19 de Julio del 2022, lista para su uso"
                value={form.value.details}
                onChange={value => form.change("details", value)}
                height="60px"
                showCharCounter={false} 
                maxLength={300}/>
            <Row width="100%" justifyContent={isAdmin ? "space-between" : "flex-end"}>
                {isAdmin &&
                <Row justifyContent="flex-start" gap="5px">
                    <CustomCheckbox 
                        variant="switch"
                        size="10px" 
                        label="Activo"
                        labelColor="var(--light-gray-4)"
                        checked={active}
                        onChange={changeActiveField}
                        disabled={isCreate}/>
                    <TooltipButton 
                        message={`Recuerda que podrás activar o desactivar la ${currentTextService.minus.singular}.`}/>
                </Row>}
                <Column width="max-content" align="flex-end">
                    {!isCreate && 
                    <ChangeHistory 
                        resource={{
                            id: form.value.id,
                            resourceTypeId,
                            name
                        }}
                        loadingRequest={loadingRequest}/>}
                    <RequiredInformationForm/> 
                </Column>
            </Row>
        </Container>
    );
}

export default Fields;